export const SAFE_CONTEXT_INITIAL_VALUE = Symbol('SAFE_CONTEXT_INITIAL_VALUE');

export type SafeContextInitialValue = typeof SAFE_CONTEXT_INITIAL_VALUE;
